import { useSuspenseQuery } from "@tanstack/react-query";
import { Flex, PrimarySecondaryPage } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";
import { OnboardingStepper } from "onboarding";

import { DocumentUploadSupportingContent } from "../../../components";
import { getCustomerBusinessModelQueryOptions } from "../../../queries/customer-data/queries";
import { useDocumentQuery } from "../../../queries/document-uploads/queries";
import { useFundingApplication } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import { getAccountingThreshold } from "../../../utils/funding-journey";
import { DocumentNavigationGroup, ManagementAccountDocumentUpload } from "../components";

export const ManagementAccountsDocumentUploadPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: businessModel } = useSuspenseQuery(getCustomerBusinessModelQueryOptions(customerDomain));
  const { data: fundingApplicationData } = useFundingApplication(customerDomain);
  const { data: uploadedDocuments } = useDocumentQuery(customerDomain, fundingApplicationData.id);
  const hasUploadedDocuments = !!uploadedDocuments?.filter(
    (doc) => doc.documentType === UploadDocumentType.MANAGEMENT_ACCOUNTS
  ).length;

  const requiredDuration =
    fundingApplicationData.requestedAmount &&
    fundingApplicationData.requestedAmountCurrency &&
    fundingApplicationData.requestedAmount >=
      4 * getAccountingThreshold(businessModel)[fundingApplicationData.requestedAmountCurrency]
      ? 24
      : 12;

  const PrimaryContent = (
    <Flex direction="column" gap="8">
      <ManagementAccountDocumentUpload duration={requiredDuration} />
      <DocumentNavigationGroup isStepComplete={hasUploadedDocuments} forType={UploadDocumentType.MANAGEMENT_ACCOUNTS} />
    </Flex>
  );

  return (
    <PrimarySecondaryPage
      titleSlot={<OnboardingStepper currentStep={4} />}
      showStepperBackground={true}
      title={intl.formatMessage({
        id: "funding-application: upload management accounts",
        defaultMessage: "Upload your management accounts",
      })}
      primaryContent={PrimaryContent}
      secondaryContent={<DocumentUploadSupportingContent />}
    />
  );
};
